import { useState } from 'react';
import { useTranslation } from "react-i18next";

const NewInputGenericRegisterPassword = ({ handleChange, values, errors, placeholderVal,
  field, max_length, moduleText, occupation = 6, css_class, onFocus, onBlur }) => {
  const { t } = useTranslation();

  const [showEyeOpen, setShowEyeOpen] = useState(true);
  const [inputType, setInputType] = useState("password");

  const handleOnEyeClick = () => {
    if (inputType === "password") {
      setInputType("text");
      setShowEyeOpen(false);
    }
    else {
      setInputType("password");
      setShowEyeOpen(true);
    }
  }

  return (
    <div className={`col-md-${occupation}`}>
      <label htmlFor={field} className="form-label">
        {t(`${moduleText}.short.${field}`)}
      </label>
      <div className="control">

        <div className="group-input-icon">
          <input
            type={inputType}
            className={`form-control form-control-lg ${errors[field] && "is-invalid"}`}
            
            placeholder={placeholderVal ? t(`${moduleText}.short.${field}`) : null}

            value={values[field] || ""}
            
            onChange={(event) => handleChange(event, field)}
            onFocus={onFocus}
            onBlur={onBlur}
            name={field}
            id={field}
          />
          <i onClick={handleOnEyeClick} className={`icon-eye fa ${showEyeOpen ? "fa-eye-slash" : "fa-eye"}`}></i>
        </div>

        {/*<input
          autoComplete="off"

          className={`form-control form-control-lg ${errors[field] && "is-invalid"}`}
          
          type={isPasswordVisible ? "text" : "password"}
          name={field}
          id={field}
          onChange={(event) => handleChange(event, field)}
          value={values[field] || ""}
          required
          maxLength={max_length}
          placeholder={placeholderVal ? t(`${moduleText}.short.${field}`) : null}
        />
        <span className="password-toggle" onClick={onPasswordClick} >
          <i className="fa-solid fa-eye"></i>
        </span>*/}

        {/*<button onClick={onPasswordClick} className="search-button">
          <i className="fa fa-eye" aria-hidden="true"></i>
        </button>*/}
        {errors[field] && <pre> <p className="help text-danger">{errors[field]}</p> </pre>}
      </div>
    </div>
  )
}

export default NewInputGenericRegisterPassword

